<template>
  <div class="update-prompt" v-if="needRefresh" role="status" aria-live="polite">
    <div class="prompt-content">
      <div class="prompt-icon">
        <i class="pi pi-refresh"></i>
      </div>
      <div class="prompt-text">
        <h4>{{ $t('appUpdate.title') }}</h4>
        <p>{{ $t('appUpdate.description') }}</p>
      </div>
      <div class="prompt-actions">
        <Button
          :label="$t('appUpdate.reload')"
          :loading="updating"
          @click="reload"
          class="p-button-sm p-button-primary"
        />
        <Button
          icon="pi pi-times"
          :aria-label="$t('common.actions.close')"
          @click="dismiss"
          class="p-button-text p-button-sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import Button from 'primevue/button'
import { usePwaUpdate } from '../composables/usePwaUpdate.js'

export default {
  name: 'PwaUpdatePrompt',
  components: {
    Button
  },
  setup() {
    const { needRefresh, applyUpdate, dismiss } = usePwaUpdate()
    const updating = ref(false)

    const reload = async () => {
      updating.value = true
      try {
        await applyUpdate()
      } catch (e) {
        // If applying the update fails, let the user try again rather than
        // leaving the button stuck in a loading state.
        updating.value = false
      }
    }

    return {
      needRefresh,
      updating,
      reload,
      dismiss
    }
  }
}
</script>

<style scoped>
.update-prompt {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border: 1px solid #e9ecef;
  z-index: 1100;
  max-width: 400px;
  margin: 0 auto;
}

.prompt-content {
  display: flex;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
}

.prompt-icon {
  font-size: 1.5rem;
  color: var(--accent-color, #1976d2);
}

.prompt-text {
  flex: 1;
}

.prompt-text h4 {
  margin: 0 0 0.25rem 0;
  font-size: 1rem;
  color: #212529;
}

.prompt-text p {
  margin: 0;
  font-size: 0.875rem;
  color: #6c757d;
}

.prompt-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

@media (max-width: 768px) {
  .update-prompt {
    left: 0.5rem;
    right: 0.5rem;
  }
}
</style>
